import React, { useState } from "react";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import image from "../../assets/images/image-depan.png";
import mp from "../../assets/images/mp2.png";
import { useAuth } from "context/AuthContext";
import { loginRequest } from "../../services/auth";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await loginRequest(form);
      if (response?.data) {
        login(response.data);
        message.success("Login berhasil! Selamat datang 👋");
        navigate("/dashboard", { replace: true });
      } else {
        setError(response?.message || "Login gagal!");
      }
    } catch (err) {
      if (err) {
        setError(err.data.error);
      } else {
        setError("Network error. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-image-side">
          <img src={image} alt="Courier" />
        </div>

        <div className="login-form-side">
          <div className="login-header">
            <img src={mp} alt="Mitran Pack Logo" className="login-logo" />
            <h2>Hi, Mitrans 👋</h2>
            <p>Pastikan akun kamu telah terdaftar pada bagian administrasi!</p>
          </div>
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                className="login-input"
                type="text"
                name="username"
                placeholder="Username"
                value={form.username}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <input
                className="login-input"
                type="password"
                name="password"
                placeholder="Password"
                value={form.password}
                onChange={handleChange}
              />
            </div>
            <button type="submit" className="login-button" disabled={loading}>
              Login
              {loading && (
                <FontAwesomeIcon icon={faSpinner} className="fa-spin spinner" />
              )}
            </button>
            {error && <p className="error-message">{error}</p>}
          </form>
        </div>
      </div>
    </div>
  );
}
